import Drawer from '@mui/material/Drawer';
import React from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

function DrawerButton({
	buttonText,
	ButtonProps = {},
	DrawerProps = {},
	children,
	startIcon,
	endIcon,
	onOpen,
	onClose,
	isOpen,
}) {
	const { sx: buttonSx, ...restButtonProps } = ButtonProps;

	const drawerPaperSx = DrawerProps.PaperProps?.sx;
	let normalizedPaperSx = [];

	if (Array.isArray(drawerPaperSx)) {
		normalizedPaperSx = drawerPaperSx;
	} else if (drawerPaperSx) {
		normalizedPaperSx = [drawerPaperSx];
	}

	const paperSx = [
		{
			display: 'flex',
			flexDirection: 'column',
		},
		...normalizedPaperSx,
	];

	return (
		<>
			<Button
				variant="text"
				color="primary"
				size="large"
				role="button"
				data-testid="reset-button"
				aria-label="reset-button"
				startIcon={startIcon}
				endIcon={endIcon}
				onClick={() => (isOpen ? onClose : onOpen)()}
				sx={{
					whiteSpace: 'nowrap',
					...(buttonSx || {}),
				}}
				{...restButtonProps}
			>
				{buttonText}
			</Button>
			<Drawer
				{...DrawerProps}
				data-testid="drawer"
				anchor="right"
				open={isOpen}
				onClose={() => onClose()}
				ModalProps={{
					BackdropProps: { invisible: true },
					...(DrawerProps.ModalProps || {}),
				}}
				PaperProps={{
					...DrawerProps.PaperProps,
					sx: paperSx,
				}}
			>
				{children}
			</Drawer>
		</>
	);
}

DrawerButton.propTypes = {
	buttonText: PropTypes.any.isRequired,
	ButtonProps: PropTypes.any,
	DrawerProps: PropTypes.any,
	startIcon: PropTypes.any,
	endIcon: PropTypes.any,
	onOpen: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	isOpen: PropTypes.bool.isRequired,
	children: PropTypes.node,
};

export default React.memo(DrawerButton);
